module.exports = __webpack_public_path__ + "img/layer-building.5e9c6c53.png";